import queryString from 'query-string';
import { ACTIONS } from '../Constants';
import { VerbFetch } from '../VerbFetch';

export const postPeerRecommendations = (params) => {
    const { pathsContext, ...rest } = params;
    const fetchOptions = {
        method: 'POST',
        body: rest
    };
    return (dispatch) =>
        VerbFetch(`${pathsContext.serverUrl}/peerrecommendations`, fetchOptions)
            .then((body) => {
                dispatch({
                    type: ACTIONS.POST_RECOMMENDATIONS,
                    payload: { recommendation: body }
                });
                return body;
            })
            .catch((err) => {
                console.error(err);
                throw err;
            });
};

export const putPeerRecommendations = (params) => {
    const { body, recommendationId, pathsContext } = params;
    const fetchOptions = {
        method: 'PUT',
        body
    };
    return (dispatch) =>
        VerbFetch(`${pathsContext.serverUrl}/peerrecommendations/${recommendationId}`, fetchOptions).then((body) => {
            dispatch({
                type: ACTIONS.PUT_RECOMMENDATIONS,
                payload: { recommendation: body }
            });
            return body;
        });
};

export const getManyPeerRecommendations = (params) => {
    const { pathsContext, ...rest } = params;

    let newQuery;
    if (rest) {
        newQuery = queryString.stringify(rest);
    }
    return (dispatch) => {
        const url = `${pathsContext.serverUrl}/peerrecommendations?${newQuery}`;
        return VerbFetch(url).then((body) => {
            dispatch({
                type: ACTIONS.GET_MANY_RECOMMENDATIONS_LEARNING_ASSETS,
                payload: { recommendations: body.learningAssetRecommendations }
            });
            dispatch({
                type: ACTIONS.GET_MANY_RECOMMENDATIONS_COLLECTIONS,
                payload: { recommendations: body.collectionRecommendations }
            });
            dispatch({
                type: ACTIONS.GET_MANY_RECOMMENDATIONS_PATHWAYS,
                payload: { recommendations: body.pathwayRecommendations }
            });
            return body;
        });
    };
};

export const updatePeerRecommendations = ({ recommendations, pathsContext }) => (dispatch) =>
    VerbFetch(`${pathsContext.serverUrl}/peerrecommendations/update`, {
        method: 'PUT',
        body: JSON.stringify({ recommendations })
    }).then(() => {
        dispatch({
            type: ACTIONS.PUT_MANY_RECOMMENDATIONS,
            payload: { recommendations }
        });
    });
